import React from 'react';
import { CardTitle, CardSubhead } from '@spark/ui-components/components/Card';

const ClientesHeader = ({
  totalRegistros,
  onAdicionar
}) => <div style={{
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 20
}}>
    <div>
      <CardTitle>Clientes</CardTitle>
      <CardSubhead>Total de registros: {totalRegistros}</CardSubhead>
    </div>
    {onAdicionar}
  </div>;

export default ClientesHeader;
